'use strict';

export default class DrupalVTabs {
  constructor(options) {
    console.log('drupalVTabs module');

    const defaults = {
      context: $(document),
      form: '.search form',
      fieldsets: '.search form fieldset'
    };

    this.options = Object.assign({}, defaults, options);

    this.form = $(this.options.form);
    this.fieldsets = $(this.options.fieldsets);

    this._prepare()
        ._wrapFieldsets()
        ._createTabs()
        ._wrapTabs()
        ._listemTabsClick()
        ._done();
  }

  _prepare() {

    this.form.addClass('is-loading');

    return this;

  }

  _done() {

    setTimeout(function(){
      this.form.removeClass('is-loading').addClass('is-loaded');
    }.bind(this), 500);


    return this;

  }

  _wrapTabs() {

    this.form.addClass('vertical-tabs');

    return this;
  }

  _listemTabsClick() {
    this.tabsItens = this.form.find('.vertical-tab-button');

    this.tabsItens.each(function(i,elem){

        $(elem).on('click touchend', function(evt){
            this._goTo(i);
        }.bind(this));

    }.bind(this));

    return this;

  }

  _goTo(idx) {
    this.tabsItens.removeClass('selected').eq(idx).addClass('selected');
    this.fieldsets.hide().eq(idx).show();
  }

  _wrapFieldsets() {

    this.verticalTabsPanes = this.fieldsets.wrapAll('<div class="vertical-tabs-panes vertical-tabs-processed"/>');

    return this;

  }

  _createTabs() {

    // Create the tab column.
    let tab_list = $('<ul class="vertical-tabs-list"></ul>');

    this.fieldsets.each(function(){

        let tab = {
            title: $('> legend', this).text(),
            fieldset: $(this)
        };

        let vertical_tab = $('<li class="vertical-tab-button"><a href="#"><strong>'+tab.title+'</strong><span class="summary"></span><span class="element-invisible">(active tab)</span></a></li>');
        tab_list.append(vertical_tab);

        $(this)
          .removeClass('collapsible collapsed')
          .addClass('vertical-tabs-pane')
          .data('verticalTab', vertical_tab);
    });

    $('> li:first', tab_list).addClass('first');
    $('> li:last', tab_list).addClass('last');

    tab_list.insertBefore($('.vertical-tabs-panes'));

    ///////////////////////////

    this.fieldsets.hide();
    const config = {
      'maisons-de-retraite': 'mr',
      'residence-seniors': 'rs',
      'residences-seniors': 'rs',
      'aide-a-domicile': 'ad',
    };

    let elm = config[window.location.pathname.split('/').slice(1,2)];

    if (elm !== void 0) {
      this.fieldsets.each(function (i) {
        if (this.id === ('edit-' + elm + '-search')) {
          $(this).show();
          $('> li', tab_list).eq(i).addClass('selected');
        }
      })

    }
    else {
      $('> li:first', tab_list).addClass('selected');
      this.fieldsets.eq(0).show();
    }


    return this;

  }


}
